/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Critères de recherche / remplacement de masse sur les lignes d'un import. Les index de colonnes sont
 * positionnels : ce sont les positions dans les colonnes figées à l'extraction. La recherche porte sur
 * les valeurs source, celles que le remplacement écrit.
 */
export interface ImportLineSearchCriteriaDto {
    searchTerm?: string;
    /** Colonnes dans lesquelles chercher. Au moins une est exigée. */
    selectedColumns?: Array<number>;
    caseSensitive?: boolean;
    replaceWith?: string;
    /** Cherche les valeurs vides ou nulles ; searchTerm est alors ignoré. */
    searchEmpty?: boolean;
    /** Restreint les lignes à celles dont cette colonne vaut filterValue. */
    filterColumnIndex?: number;
    filterValue?: string;
    /** Colonne où écrire le remplacement ; absent = la colonne du match. */
    targetColumnIndex?: number;
    /** Si renseigné, la valeur de remplacement est copiée depuis cette colonne, ligne par ligne. */
    valueSourceColumnIndex?: number;
    replaceType?: ImportLineSearchCriteriaDto.ReplaceTypeEnum;
    /** Restreint la recherche aux lignes dans cet état ; absent pour toutes (hors importées). */
    status?: string;
}
export namespace ImportLineSearchCriteriaDto {
    /** first : première occurrence dans la cellule ; all : toutes ; overwrite : écrase toute la cellule. */
    export type ReplaceTypeEnum = 'first' | 'all' | 'overwrite';
    export const ReplaceTypeEnum = {
        First: 'first' as ReplaceTypeEnum,
        All: 'all' as ReplaceTypeEnum,
        Overwrite: 'overwrite' as ReplaceTypeEnum
    };
}
